module.exports = __webpack_public_path__ + "static/Gotham-Medium-2bf42cd0881aa069c6c5adc538fa3e76.woff";